import { useEffect, useRef } from "react";

export const useTitle = (title: string) => {
  const documentDefined = typeof document !== "undefined";
  const originalTitle = useRef(documentDefined ? document.title : null);
  useEffect(() => {
    const originalTitleCurrent = originalTitle.current;
    if (!documentDefined) return;
    if (document.title !== title) document.title = title;
    return () => {
      document.title = originalTitleCurrent ?? "";
    };
  }, [documentDefined, title]);
};
